import React from "react";
import { Helmet } from "react-helmet";
import PropTypes from "prop-types";
import Slider from "react-slick";
import Masonry from "react-masonry-css";
import { useState, useEffect, useRef } from "react";
import {
	Title,
	FilterNav,
	Cards,
	Container,
	FilterDropdown,
	EmailWrapper,
	Header,
	LoadMoreButton,
} from "./styles";
import Card from "./Cards";
import { EmailForm } from "../../Elements";
import { Select } from "@website-builder/ui/shared/elements";

import {
	getSegmentAnonymousId,
	addToDataLayer,
	getVwoCampaignId,
	getGclid,
	GetReferrer,
	GetReferrerUtmParams,
	getUniqueUserId,
	GTM_EVENT_TIMEOUT,
	DESKTOP_SM_BP,
	WAIT_TIME_FOR_ANALYTICS,
} from "@website-builder/utilities-index";

let dropDownOptions = [];
const ReviewsFilter = (props) => {
	const settings = {
		slidesToScroll: 1,
		arrows: true,
		responsive: [
			{
				breakpoint: DESKTOP_SM_BP,
				settings: "unslick",
			},
		],
	};
	const {
		header,
		courses,
		courseInfo,
		cards,
		fullWidthCTAHeader,
		CtaBackgroundColor,
		cta,
		context,
		pageSection,
	} = props;

	const { apiBaseUrl, slug, springformId } = context;
	const apiEndPoint = `${apiBaseUrl}/learning-paths/interested/`;
	const uuid = getUniqueUserId();
	const [currentCourse, setCurrentCourse] = useState(courses[0]);
	const [filteredCourses, setFilteredCourses] = useState([]);
	const [courseCredntials, setCourseCredentials] = useState({
		typeform_link: "",
		workshop_id: "",
		drip_tag_prefix: "",
	});

	const listRef = useRef({});
	let [size, setSize] = useState(null);
	let [limit, setLimit] = useState(6);

	const formData = {
		apply: 1,
		js_disabled: "yes",
		lead_type: "SA",
		workshop_id: courseCredntials["workshop_id"],
		drip_tag_prefix: courseCredntials["drip_tag_prefix"],
		uuid: uuid,
	};

	const handleResize = () => {
		setSize(window.innerWidth);
	};

	useEffect(() => {
		courses.forEach((data) => {
			dropDownOptions.push({
				value: data,
				label: data,
			});
		});

		listRef.current[currentCourse].classList.add("checked");

		setSize(window.innerWidth);
		window.addEventListener("resize", handleResize);
		return () => {
			window.removeEventListener("resize", handleResize);
		};
	}, []);

	function onChange(e) {
		setCurrentCourse(e.target.innerHTML);
		Object.keys(listRef.current).forEach((el) => {
			listRef.current[el].classList.remove("checked");
		});
		listRef.current[e.target.innerHTML].classList.add("checked");
	}

	useEffect(() => {
		setCredentials();
		let filterCourse = [];
		cards.forEach((card) => {
			if (card["course"] == currentCourse) filterCourse.push(card);
		});
		setFilteredCourses(filterCourse);
	}, [currentCourse]);

	const setCredentials = () => {
		courseInfo.forEach((course) => {
			if (course["name"] == currentCourse)
				return setCourseCredentials({
					typeform_link: course["typeformLink"],
					workshop_id: course["workshop_id"],
					drip_tag_prefix: course["drip_tag_prefix"],
				});
		});
		return "";
	};

	const callAnalyticsEvent = (email) => {
		const [referral, referral2] = GetReferrer();
		const campaignVariationIdStr = getVwoCampaignId();
		//send segment event if the user is being referred by a friend
		let referrerIdentifier = localStorage.getItem("referrer_identifier");
		let referralCode = localStorage.getItem("referral_code");

		if (referralCode && referrerIdentifier) {
			addToDataLayer({
				event: "friend_referral_code_apply",
				referrer_identifier: referrerIdentifier,
				referral_code: referralCode,
			});
		}

		const workshop_id = courseCredntials["workshop_id"];
		if (!!window["google_tag_manager"]) {
			//Trigger GA4 and Segment Event through GTM
			addToDataLayer({
				event: "application_start",
				lead_type: "app_start",
				page_section: pageSection,
				course_slug: slug,
				email,
				variation_id: campaignVariationIdStr,
				referral,
				referral2,
				products: JSON.stringify([{ product_id: workshop_id }]),
				eventCallback: function (id) {
					if (id === process.env.GATSBY_GTM_CONTAINER_ID) {
						setTimeout(redirectToTypeform, WAIT_TIME_FOR_ANALYTICS, email);
					}
				},
				eventTimeout: GTM_EVENT_TIMEOUT,
			});
		} else {
			console.error("GTM DOESN'T EXIST!");
			redirectToTypeform(email);
		}
	};

	const redirectToTypeform = (email) => {
		const [referral, referral2] = GetReferrer();
		const campaignVariationIdStr = getVwoCampaignId();
		if (springformId) {
			return window.location.assign(
				`${
					window.location.origin
				}/courses/apply/${slug}?email=${encodeURIComponent(email)}`,
			);
		}

		const referrerUtmParams = GetReferrerUtmParams();
		const gclid = getGclid();

		const params = new URLSearchParams({
			uuid,
			referral,
			referral2,
			email,
			segmentanonymousid: getSegmentAnonymousId(),
			...(campaignVariationIdStr && { variationid: campaignVariationIdStr }),
			...(gclid && { gclid }),
			...referrerUtmParams,
		}).toString();

		let typeformUrl = `${courseCredntials["typeform_link"]}?&${params}`;

		if (window.qp && window.qp instanceof Function) {
			window.qp("track", "GenerateLead");
		}
		window.open(typeformUrl, "_blank");
	};

	function RenderCards() {
		let arr = [];
		for (let i = 0; i < filteredCourses.length; i += 4) {
			arr.push(filteredCourses.slice(i, i + 4));
		}
		return arr;
	}
	return (
		<div>
			<Helmet>
				<link
					rel="stylesheet"
					type="text/css"
					charset="UTF-8"
					href="https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.6.0/slick.min.css"
				/>
				<link
					rel="stylesheet"
					type="text/css"
					href="https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.6.0/slick-theme.min.css"
				/>
			</Helmet>
			<Container>
				<Title>{header}</Title>
				<FilterDropdown>
					<Select
						value={currentCourse}
						onChange={(event) => setCurrentCourse(event?.target?.value)}
					>
						{dropDownOptions.map((item, index) => (
							<option value={item?.value} key={index}>
								{item?.label}
							</option>
						))}
					</Select>
				</FilterDropdown>
				<FilterNav>
					<ul className="course">
						{courses.map((course, index) => (
							<li
								ref={(node) => {
									listRef.current[course] = node;
								}}
								key={index}
								value={course}
								onClick={(e) => onChange(e)}
								className="courseName"
							>
								{course}
							</li>
						))}
					</ul>
				</FilterNav>
				{size > DESKTOP_SM_BP ? (
					<Cards>
						<div>
							<Slider {...settings}>
								{RenderCards().map((cards, index) => (
									<Masonry
										breakpointCols={2}
										className="my-masonry-grid"
										columnClassName="my-masonry-grid_column"
									>
										{cards.map((card, index) => (
											<Card key={index} {...card} />
										))}
									</Masonry>
								))}
							</Slider>
						</div>
					</Cards>
				) : (
					<div className="reviews-card">
						<Cards>
							{filteredCourses.slice(0, limit).map((card) => (
								<Card {...card} />
							))}
						</Cards>
						{filteredCourses.length > limit && (
							<LoadMoreButton
								onClick={() => setLimit((oldLimit) => oldLimit + 6)}
							>
								<span className="loadMore">Load more</span>
							</LoadMoreButton>
						)}
					</div>
				)}
				<EmailWrapper backgroundColor={CtaBackgroundColor.color}>
					<Header>{fullWidthCTAHeader}</Header>
					<EmailForm
						className="start-application-form"
						formData={formData}
						redirectUrl={courseCredntials["typeform_link"]}
						apiEndPoint={apiEndPoint}
						actionOnSuccess="CALLBACK"
						callbackOnSuccess={callAnalyticsEvent}
						buttonText={cta}
					></EmailForm>
				</EmailWrapper>
			</Container>
		</div>
	);
};

ReviewsFilter.propTypes = {
	header: PropTypes.string,
	courses: PropTypes.array,
	cards: PropTypes.array,
	fullWidthCTAHeader: PropTypes.string,
	cta: PropTypes.string,
	CtaBackgroundColor: PropTypes.string,
};

ReviewsFilter.defaultProps = {
	header: "",
	courses: "",
	cards: [],
	fullWidthCTAHeader: "",
	cta: "",
	CtaBackgroundColor: "",
};

export default ReviewsFilter;
